import ProofOfMortgageTileSvg from '@assets/images/svg/proof-of-mortgage-tile.svg';
import React from 'react';
import { View } from 'react-native';

export interface ProofOfMortgageTileIconProps {
    size?: number;
    color?: string;
}

/** Self-contained tile (grey rounded box + glyph baked in) for the "Proof of Mortgage" payment method row. */
export function ProofOfMortgageTileIcon({ size = 44, color = '#1A1A1A' }: Readonly<ProofOfMortgageTileIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ProofOfMortgageTileSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ProofOfMortgageTileIcon;
